$soupmail.helpers = {


    SoupMailDate: function SoupMailDate(dateString) {

		if (dateString) {
			this._date = new Date(dateString);
		} else {
			this._date = new Date();
		}

		this.decoder = {};

		this.today = function() {

			this.decoder.today = new $soupmail.helpers.SoupMailDate();
			this.decoder.today._date = new Date();
			return this.decoder.today;

		}

		this.morning = function() {
			this._date.setHours(0);
			this._date.setMinutes(0);
			this._date.setSeconds(0);
			return this;
		}

		this.night = function() {
			this._date.setHours(23);
			this._date.setMinutes(59);
			this._date.setSeconds(59);
			return this;
		}

		this.minusDays = function($numberOfDays) {
			this._date.setDate(this._date.getDate() - $numberOfDays);
			return this;
		}

		this.plusDays = function($numberOfDays) {
			this._date.setDate(this._date.getDate() + $numberOfDays);
			return this;
		}

		this.minusMonths = function($numberOfMonths) {
			this._date.setMonth(this._date.getMonth() - $numberOfMonths);
			return this;
		}

		this.plusMonths = function($numberOfMonths) {
			this._date.setMonth(this._date.getMonth() + $numberOfMonths);
			return this;
		}

		this.toTimezoneOffset = function() {
			$offsetHours = (parseInt(this._date.getTimezoneOffset() / 60) * -1);
			return (($offsetHours < 0) ? ('-'+$offsetHours+'00') : ('+'+$offsetHours+'00'));
		}

		this.toUTCString = function() {
			// returns, for example: Fri, 30 Jul 2010 15:05:00 UTC
			return this._date.toUTCString();
		}

		this.toString = function($format) {

			this.decoder.d_names = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
			this.decoder.d_names_short = new Array("Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat");
			this.decoder.m_names = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
			this.decoder.m_names_short = new Array("Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec");
			this.decoder.curr_month = this._date.getMonth();
			this.decoder.curr_month_str = (this._date.getMonth()+1);
			if (this.decoder.curr_month_str < 10) { this.decoder.curr_month_str = '0' + this.decoder.curr_month_str; }
			this.decoder.curr_day = this._date.getDay();
			this.decoder.curr_daymonth = this._date.getDate();
			this.decoder.curr_daymonth_str = ((this.decoder.curr_daymonth < 10) ? ('0' + this.decoder.curr_daymonth) : this.decoder.curr_daymonth);
			this.decoder.curr_hour = this._date.getHours();
			this.decoder.curr_am_pm = ((this.decoder.curr_hour < 12) ? 'AM' : 'PM');
			if (this.decoder.curr_hour == 0) { this.decoder.curr_hour = 12; } if (this.decoder.curr_hour > 12) { this.decoder.curr_hour -= 12; }
			this.decoder.curr_min = this._date.getMinutes() + "";
			if (this.decoder.curr_min.length == 1) { this.decoder.curr_min = "0" + this.decoder.curr_min; }

			this.decoder.output = '';
			for (var i=0; i < $format.length; i++) {

				this.decoder.char = $format.charAt(i);
				this.decoder.newChar = this.decoder.char;
				if (this.decoder.char == 'g') { this.decoder.newChar = this.decoder.curr_hour; }					// 12-hour format of an hour without leading zeros
				if (this.decoder.char == 'i') { this.decoder.newChar = this.decoder.curr_min; }					// Minutes with leading zeros
				if (this.decoder.char == 'a') { this.decoder.newChar = this.decoder.curr_am_pm.toLowerCase(); }			// Lowercase am or pm
				if (this.decoder.char == 'A') { this.decoder.newChar = this.decoder.curr_am_pm; }					// Uppercase AM or PM
				if (this.decoder.char == 'd') { this.decoder.newChar = this.decoder.curr_daymonth_str; }				// Day of the month, 2 digits with leading zeros
				if (this.decoder.char == 'm') { this.decoder.newChar = this.decoder.curr_month_str; }				// Numeric representation of a month, with leading zeros
				if (this.decoder.char == 'y') { this.decoder.newChar = this._date.getYear(); }					// A two digit representation of a year
				if (this.decoder.char == 'Y') { this.decoder.newChar = this._date.getFullYear(); }					// A full numeric representation of a year, 4 digits
				if (this.decoder.char == 'D') { this.decoder.newChar = this.decoder.d_names_short[this.decoder.curr_day]; }		// A textual representation of a day, three letters
				if (this.decoder.char == 'l') { this.decoder.newChar = this.decoder.d_names[this.decoder.curr_day]; }		// A full textual representation of the day of the week
				if (this.decoder.char == 'M') { this.decoder.newChar = this.decoder.m_names_short[this.decoder.curr_month]; }	// A short textual representation of a month, three letters, e.g. Jan or Mar
				if (this.decoder.char == 'F') { this.decoder.newChar = this.decoder.m_names[this.decoder.curr_month]; }		// A full textual representation of a month, such as January or March
				this.decoder.output += this.decoder.newChar;

			}

			return this.decoder.output;

		}

		this.getDashboardDate = function() {

			// date should be time only if it is today (e.g. 9:30am)
			if (this.toString('Y-m-d') == this.today().toString('Y-m-d')) {
				return this.toString('g:ia');
			}

			// date should be 3-character day of week if in the past 7 days, plus time (e.g. Tue 2:43pm)
			if (parseInt(this.toString('Ymd')) > parseInt(this.today().minusDays(7).toString('Ymd'))) {
				return this.toString('D g:ia');
			}

			// date should be dd/mm/yy in all other circumstances - or whatever date format your region uses  (mm/dd/yy or mm.dd.yy for example)
			return this.toString('d/m/Y');

		}

		this.getEmailPreviewDate = function() {

			// date should be time if it is today (e.g. Today, at 9:30am)
			if (this.toString('Y-m-d') == this.today().toString('Y-m-d')) {
				return 'Today, at '+this.toString('g:ia');
			}

			// date should be day of week if in the past 7 days, plus time (e.g. Tuesday, at 2:43pm)
			if (parseInt(this.toString('Ymd')) > parseInt(this.today().minusDays(7).toString('Ymd'))) {
				return this.toString('l') + ', at ' + this.toString('g:ia');
			}

			// date should be like Tuesday 10 April 2012 in all other circumstances - or whatever date format your region uses  (mm/dd/yy or mm.dd.yy for example)
			return this.toString('l, d F Y g:ia');

		}

	}

}



// WEBPACK FOOTER //
// ./src/js/helpers/soupmail.helper.date.js